import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ctv-status-box',
  template: `
    <span
      class="status-plate status-plate--{{ status.color }}"
      (click)="onClick()"
      [ngClass]="{ 'status-plate-active': activeBox, 'status-plate-mini': mini }"
    >
      <small *ngIf="status.label" style="text-transform: capitalize;">{{ status.label.toLowerCase() }}</small>
      <p *ngIf="status.count !== null && status.count !== undefined">{{ status.count }}</p>
      <ng-content></ng-content>
    </span>
  `,
})
export class StatusBoxComponent {
  @Input()
  public status;
  @Input()
  public activeBox = false;
  @Input() mini = false;

  @Output()
  statusClicked = new EventEmitter();

  onClick() {
    this.statusClicked.emit(this.status.statusName);
  }
}
